<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        {{ itemInfo.GoEvent_Desc }}
        <template v-slot:action>
          <q-btn v-close-popup flat icon="close" round/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <q-table
          :data="items"
          row-key="Goods_IDD"
          flat
          hide-header
          :rows-per-page-options="[0]">
        <template v-slot:body="props">
          <q-tr :props="props" class="my-class">
            <q-td>
              <q-card flat>
                <q-card-section class="text-subtitle2 no-padding">
                  <div>
                    <q-btn icon="check" padding="none" color="green"
                           text-color="white" round @click="confirmRecords(props.row)"/>
                    <q-chip clickable square @click="showProductDetails(props.row)" class="q-ml-xs" rounded color="red"
                            text-color="white"
                            :label="props.row.Goods_Code"/>
                    {{ props.row.Goods_Name }}
                    <q-chip square :label="props.row.StorName">
                      <q-badge class="q-ml-xs" rounded color="red-14" text-color="white"
                               :label="props.row.GoEvent_Ind===311 ? props.row.GoEvent_StIn: Math.abs(props.row.GoEvent_StOut)"/>
                      {{props.row.Unit_Name}}
                    </q-chip>
                  </div>
                </q-card-section>
              </q-card>
            </q-td>
          </q-tr>
        </template>
      </q-table>

    </q-card-section>

    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showProductDetailsDialog">
      <ProductDetail :product="selectedProductDetails"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import ProductDetail from "@/components/productInfo/ProductDetail.vue";

export default {
  name: "GoodsReceiveConfirm",
  components: {ProductDetail},
  props: {
    itemInfo: {
      type: Object
    },
    items: {
      type: Array,
      default:() => []
    }
  },
  data() {
    return {
      selectedProductDetails: '',
      showProductDetailsDialog: false
    }
  },
  methods: {
    ...mapActions({
      setConfirm: 'Products/setGoodsTransferRequestConfirm',
      getProductInfo: 'Products/getProductInfo'

    }),
    showProductDetails(row) {
      this.getProductInfo(row.Goods_ID).then((res) => {
        this.selectedProductDetails = res[0];
        this.showProductDetailsDialog = true
      })
    },
    confirmRecords(row) {
      if
      (
          !row.BuyLast_Price || row.BuyLast_Price === 0 ||
          !row.BuyDay_Price || row.BuyDay_Price === 0 ||
          !row.SaleG_Price || row.SaleG_Price === 0 ||
          !row.SaleG_Price_Box || row.SaleG_Price_Box === 0
      ) {
        this.$q.notify({
          message: `قیمت های محصول به روز نمی باشد`,
          color: 'negative',
          position: 'top',
          type: 'negative'
        });
      } else {
        this.setConfirm({
          Goods_IDD: row.Goods_IDD,
          Goods_ID: row.Goods_ID
        }).then((res) => {
          if (res.result === 1) {
            this.$emit('delete-item', row)
            this.$q.notify({
              message: `تاییدیه صادر گردید`,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>